import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@blaze-cms/nextjs-components';
import FlyOutBasketItems from './FlyOutBasketItems';
import EcommerceButton from '../EcommerceButton';
import FlyOutBasketSummary from './FlyOutBasketSummary';
import { FLYOUT_BASKET_CLASS_NAME, TARGET_CLASSES } from './constants';
import { TRANSLATION_NAMESPACE } from '../../constants';

const FlyOutBasket = ({
  basketStyle,
  basketTotalItems,
  basketItems,
  cartUrl,
  checkoutUrl,
  handleButtonClick,
  formattedTotal,
  handleHideFlyout,
  checkoutButtonText,
  viewCartButtonText,
  isBasketEmpty
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const wrapperRef = useRef(null);

  useEffect(
    () => {
      function handleClickOutside({ target, target: { className: targetClass } }) {
        const shouldHideFlyOut =
          !TARGET_CLASSES.includes(targetClass) &&
          typeof targetClass !== 'object' &&
          wrapperRef.current &&
          !wrapperRef.current.contains(target);

        if (shouldHideFlyOut) handleHideFlyout();
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    },
    [handleHideFlyout, wrapperRef]
  );

  const className = `${FLYOUT_BASKET_CLASS_NAME}__flyout`;
  const buttonsClassName = `${className}__buttons`;

  return (
    <div className={className} style={basketStyle} ref={wrapperRef}>
      {!isBasketEmpty ? (
        <>
          <FlyOutBasketItems basketItems={basketItems} className={className} />
          <FlyOutBasketSummary
            className={className}
            formattedTotal={formattedTotal}
            totalItems={basketTotalItems}
          />
        </>
      ) : (
        <div className="empty-cart-message">{t('EMPTY_CART_STRING')}</div>
      )}
      <div className={buttonsClassName}>
        <EcommerceButton
          handleOnClick={() => handleButtonClick(cartUrl)}
          buttonText={viewCartButtonText}
          className={buttonsClassName}
          modifier="cart"
          isDisabled={isBasketEmpty}
        />
        <EcommerceButton
          handleOnClick={() => handleButtonClick(checkoutUrl)}
          buttonText={checkoutButtonText}
          className={buttonsClassName}
          modifier="checkout"
          isDisabled={isBasketEmpty}
        />
      </div>
    </div>
  );
};

FlyOutBasket.propTypes = {
  handleHideFlyout: PropTypes.func.isRequired,
  basketItems: PropTypes.array.isRequired,
  basketTotalItems: PropTypes.string.isRequired,
  basketStyle: PropTypes.object.isRequired,
  cartUrl: PropTypes.string.isRequired,
  checkoutUrl: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  checkoutButtonText: PropTypes.string.isRequired,
  viewCartButtonText: PropTypes.string.isRequired,
  isBasketEmpty: PropTypes.bool.isRequired,
  formattedTotal: PropTypes.string
};

FlyOutBasket.defaultProps = {
  formattedTotal: null
};

export default FlyOutBasket;
